__webpack_require__.p = "https://tastermpoint-mfe-tracking-stage.maersk.io/mfe/tracking/";